import { X } from 'lucide-react'
import ResultsList from './ResultsList'
import ItemTypeSelector from './ItemTypeSelector'
import SearchableDropdown from './SearchableDropdown'

const AddItemPanel = ({
    itemType,
    onItemTypeChange,
    selectedCategory,
    onCategorySelect,
    categorySearch,
    onCategorySearchChange,
    isCategoryOpen,
    onCategoryToggle,
    categories,
    categoryLoading,

    selectedCollection,
    onCollectionSelect,
    collectionSearch,
    onCollectionSearchChange,
    isCollectionOpen,
    onCollectionToggle,
    collections,
    collectionLoading,

    selectedShow,
    onShowSelect,
    showSearch,
    onShowSearchChange,
    isShowOpen,
    onShowToggle,
    shows,
    showLoading,

    onShow,
    isLoading,
    results,
    selectedItem,
    onSelectItem,
    onAddItem,
    onClose,
}) => {
    const isShowType = itemType === 'show'
    const canSearch = isShowType
        ? selectedCategory && selectedCollection
        : selectedCategory && selectedCollection && selectedShow

    return (
        <div className="bg-white rounded-lg border-2 p-4">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-bold">Add Item to Carousel</h3>
                <button
                    onClick={onClose}
                    className="p-1 hover:bg-gray-200 rounded"
                >
                    <X size={20} />
                </button>
            </div>

            <ItemTypeSelector value={itemType} onChange={onItemTypeChange} />

            <div className="grid gap-4 mb-4 items-start mt-4 ">
                <div className="w-full ">
                    <SearchableDropdown
                        label="Category"
                        value={selectedCategory?.label || ''}
                        options={Array.isArray(categories) ? categories : []}
                        onSelect={onCategorySelect}
                        searchValue={categorySearch}
                        onSearchChange={onCategorySearchChange}
                        isOpen={isCategoryOpen}
                        onToggle={onCategoryToggle}
                        isLoading={categoryLoading}
                        isEmpty={false}
                    />
                </div>

                <div>
                    {' '}
                    <SearchableDropdown
                        label="Collection"
                        value={selectedCollection?.label || ''}
                        options={Array.isArray(collections) ? collections : []}
                        onSelect={onCollectionSelect}
                        searchValue={collectionSearch}
                        onSearchChange={onCollectionSearchChange}
                        isOpen={isCollectionOpen}
                        onToggle={onCollectionToggle}
                        isLoading={collectionLoading}
                        isEmpty={!selectedCategory}
                    />
                </div>
                {!isShowType && (
                    <SearchableDropdown
                        label="Show"
                        value={selectedShow?.label || ''}
                        options={Array.isArray(shows) ? shows : []}
                        onSelect={onShowSelect}
                        searchValue={showSearch}
                        onSearchChange={onShowSearchChange}
                        isOpen={isShowOpen}
                        onToggle={onShowToggle}
                        isLoading={showLoading}
                        isEmpty={!selectedCollection}
                    />
                )}

                <button
                    onClick={onShow}
                    disabled={isLoading}
                    className="bg-blue-500 hover:bg-blue-600 disabled:bg-blue-300 text-white px-6 py-2 rounded font-bold h-10 w-20 flex items-center justify-center"
                >
                    Search
                </button>
            </div>

            <ResultsList
                results={results}
                selectedItem={selectedItem}
                onSelectItem={onSelectItem}
            />

            {results && (
                <button
                    onClick={onAddItem}
                    disabled={!selectedItem}
                    className="w-full bg-blue-500 hover:bg-blue-600 disabled:bg-blue-300 text-white px-6 py-2 rounded font-bold h-10"
                >
                    Add
                </button>
            )}
        </div>
    )
}

export default AddItemPanel
